import styled from 'styled-components';

interface StyledTextareaProps {
  $hasError: boolean;
}

export const StyledFooter = styled.div`
  padding: 0 20px 12px;
`;

export const StyledForm = styled.form`
  position: relative;
`;

export const StyledTextarea = styled.textarea<StyledTextareaProps>`
  display: block;
  width: 100%;
  height: 80px;
  padding: 12px 56px 12px 14px;
  margin: 0;
  font: inherit;
  line-height: 1.5;
  color: ${({ theme }) => theme.color.grey12};
  resize: none;
  outline: none;
  scrollbar-width: none;
  background-color: ${({ theme }) => theme.color.grey97};
  border: 1px solid ${({ theme }) => theme.color.grey88};
  border-radius: 12px;
  transition: border-color 200ms linear;

  &::-webkit-scrollbar {
    display: none;
  }

  &::placeholder {
    color: ${({ theme }) => theme.color.grey52};
    opacity: 1;
  }

  &:focus {
    border-color: ${({ theme }) => theme.color.violet64};
  }

  ${({ $hasError, theme }) =>
    $hasError &&
    `
    border-color: ${theme.color.red47};

    &:focus {
      border-color: ${theme.color.red47};
    }
  `}
`;

export const StyledSend = styled.button`
  position: absolute;
  right: 8px;
  bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  padding: 0;
  cursor: pointer;
  background-color: ${({ theme }) => theme.color.violet64};
  border: none;
  border-radius: 10px;
  transition: background-color 200ms linear;

  &:disabled {
    cursor: default;
    background-color: ${({ theme }) => theme.color.grey88};
  }
`;

export const StyledNotice = styled.div`
  padding: 0 8px 4px;
  margin-top: 8px;
  font-size: ${({ theme }) => theme.size.ring};
  color: ${({ theme }) => theme.color.grey52};
  text-align: center;
`;

export const StyledNoticeLink = styled.a`
  color: ${({ theme }) => theme.color.violet64};
  text-decoration: underline;
`;
